import { useQuery } from '@tanstack/react-query';
import { apiClient, type PlatformBranding } from './api-client';

export const BRANDING_QUERY_KEY = ['public', 'branding'] as const;

/**
 * Retorna o branding da plataforma.
 * Cache perpetuo na sessao (staleTime: Infinity) — a aparencia nao muda
 * entre navegacoes. Endpoint publico, sem auth, sem retry agressivo.
 */
export function useBranding(): {
  branding: PlatformBranding | undefined;
  isPending: boolean;
} {
  const { data, isPending } = useQuery({
    queryKey: BRANDING_QUERY_KEY,
    queryFn: () => apiClient.publicGetBranding(),
    staleTime: Infinity,
    retry: 1,
    refetchOnWindowFocus: false,
  });

  return { branding: data, isPending };
}
